import { useState, ReactNode, JSX, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface Tab {
  label: JSX.Element | string;
  content: ReactNode;
  hide?: boolean;
  onClick?: () => void;
}

interface TabsProps {
  tabs: Tab[];
  defaultActiveIndex?: number;
  type?: "pills" | "default";
  tabBarClassName?: string;
  tabContainerClassName?: string;
  tabButtonClassName?: string;
  onTabChange?: (index: number) => void;
}

export default function Tabs(params: TabsProps) {
  const [activeIndex, setActiveIndex] = useState(
    params.defaultActiveIndex || 0
  );

  useEffect(() => {
    params.onTabChange?.(activeIndex);
  }, [activeIndex]);
  useEffect(() => {
    setActiveIndex(params.defaultActiveIndex!);
  }, [params.defaultActiveIndex]);

  return (
    <div className="w-full">
      <div
        className={`${params.tabBarClassName} flex-nowrap overflow-x-auto whitespace-nowrap flex border-b border-b-base-300`}
      >
        {params.tabs.map((tab, index) => (
          <button
            key={index}
            className={`font-black ${tab.hide ? "hidden" : ""} ${
              params.tabButtonClassName
            } text-sm font-medium focus:outline-none ${
              params.type == "pills"
                ? "btn btn-sm btn-outline"
                : "border-b-2 py-2 px-4"
            }  transition-all duration-200 ${
              activeIndex === index
                ? params.type != "pills"
                  ? "border-primary text-primary"
                  : "btn-primary"
                : params.type != "pills"
                ? "border-transparent text-base-300 hover:text-primary"
                : "border-base-300"
            }`}
            onClick={() => {
              tab.onClick?.();
              setActiveIndex(index);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div
        className={`relative bg-transparent rounded-b-md min-h-[100px] ${params.tabContainerClassName}`}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.25 }}
            className="absolute top-0 left-0 w-full"
          >
            {params.tabs[activeIndex!]?.content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
